module.exports = __webpack_public_path__ + "static/img/b4.c51ce32d.png";